module.exports = __webpack_public_path__ + "static/img-slide-3-4db02daf8e5d2557c8b7eb9d17b98c32.png";